import { t } from "i18next";
import { Switch } from "ui";

import {
  useSharingsSchedulesSettings,
  useUpdateSharingSchedulesSettings
} from "../../apis";
import { SharingSchedulesSettingsMode } from "../../constants";

import styles from "./SharingSchedulesModeControl.module.scss";

const SharingSchedulesModeControl = () => {
  const { mode, isLoading } = useSharingsSchedulesSettings();

  const { mutate: updateSharingSchedulesSettings } =
    useUpdateSharingSchedulesSettings();

  return (
    <div className={styles.control}>
      <p
        className={styles.control_label}
        style={{
          color:
            mode === SharingSchedulesSettingsMode.CustomSchedules
              ? "#fb3973"
              : ""
        }}
      >
        {t("Scheduled config")}
      </p>
      <Switch
        disabled={isLoading}
        onChange={(e) =>
          updateSharingSchedulesSettings({
            mode: e.target.checked
              ? SharingSchedulesSettingsMode.Random
              : SharingSchedulesSettingsMode.CustomSchedules
          })
        }
        checked={mode === SharingSchedulesSettingsMode.Random}
      />
      <p
        className={styles.control_label}
        style={{
          color: mode === SharingSchedulesSettingsMode.Random ? "#fb3973" : ""
        }}
      >
        {t("Random")}
      </p>
    </div>
  );
};

export default SharingSchedulesModeControl;
